import timestampCalculator from 'shared/lib/timestampCalculator'
import Badge from '../ScanResultBottomSheet/ui/Badge'
import Style from './style'
import {isUsedTicket} from 'shared/utils/eventUtils'

const TicketInfo = ({ticketName, data}) => {
	const isUsed = isUsedTicket(data)

	const rowData = [
		{
			title: '시리얼 번호',
			value: data?.ticket_info?.serial_number || '-',
		},
		{
			title: '대회 시간',
			value: timestampCalculator(data?.event_date) || '-',
		},
	]

	return (
		<Style.Container>
			<Style.Header>
				<Style.SectionTitle>티켓 정보</Style.SectionTitle>
			</Style.Header>

			<Style.ContentContainer>
				<Style.NameRow>
					<Style.TournamentName>
						{data?.ticket_info?.name ?? '-'}
					</Style.TournamentName>
					<Badge event_state={data?.event_state} isUsed={isUsed} />
				</Style.NameRow>
				{rowData.map((elem) => {
					if (elem?.hidden) return null
					return (
						<Style.InfoRow>
							<Style.Label>{elem.title}: </Style.Label>
							<Style.Value>{elem.value}</Style.Value>
						</Style.InfoRow>
					)
				})}
			</Style.ContentContainer>
		</Style.Container>
	)
}

export default TicketInfo
